import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('share:twitter')))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("img", {
        width: "32",
        height: "32",
        src: "images/Twitter social icons - rounded square - blue.png",
        alt: "Twitter"
      }, null, -1)
    ]))
  ]))
}